<template>
<div class="wlx-site-manager-wrapper-1">
    <div class="yk-wrap-fixed clearfix">

        <div class="u-table-main u-table-apply">
            <div class="site-head-title-con">
                站点信息：
            </div>
            <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark">
                <!-- <el-table-column prop="id" type="selection" width="55"></el-table-column> -->
                <el-table-column label="序号" type="index" width="50"></el-table-column>
                <el-table-column prop="schoolName" label="单位名称"></el-table-column>
                <el-table-column prop="responsibleProvince" label="省份"></el-table-column>
                <el-table-column prop="responsibleCity" label="城市"></el-table-column>
                <el-table-column prop="contactsName" label="联系人姓名"></el-table-column>
                <el-table-column prop="contactsPhone" label="联系人联系方式"></el-table-column>
                <el-table-column prop="IsLecturer" label="是否通过" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isPost==0">审核中</span>
                        <!-- <span v-if="scope.row.isPost==1">通过</span> -->
                        <span v-if="scope.row.isPost==1">通过 <el-button class="el-button el-button--primary" size="mini" type="primary" @click="showAuditOpinion(scope.row.auditOpinion)">查看审核意见</el-button></span>
                        <span v-if="scope.row.isPost==2">未通过 <el-button class="el-button el-button--primary" size="mini" type="primary" @click="showAuditOpinion(scope.row.auditOpinion)">查看审核意见</el-button></span>
                    </template>
                </el-table-column>
                <el-table-column prop="dateCreated" label="申请时间" width="160"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="bottom">
                            <el-button icon="el-icon-edit" size="mini" type="primary" @click="editTable(scope.row.id)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>

            <div class="exam-affairs-info">
                <h3 class="h3-title-text">考务账号信息:</h3>
                <p class="text-notice">
                    <span class="sp-text-hader">考务系统网址：<span class="sp-number-info">
                            <a href="http://kw.clppx.org.cn" target="_blank">http://kw.clppx.org.cn</a></span></span>
                    <span class="sp-text-hader">考务管理员账号：<span class="sp-number-info">{{kdName}}</span></span>
                    <span class="sp-text-hader">初始密码：<span class="sp-number-info">{{kPassword}}</span></span>
                </p>

                <p class="text-notice">1、请妥善保存考务管理员帐号和密码；帐号一般为考核站点的名称+考务两字拼音首字母缩写，初始密码一般为考核站点联系人手机号。</p>
                <p class="text-notice">2、考务管理员账号可登陆考务系统 <span class="sp-number-info"><a href="http://kw.clppx.org.cn" target="_blank">http://kw.clppx.org.cn</a></span>进行实操考题下载，上传考试情况记录表等操作。</p>
                <p class="text-notice">3、如若考务管理员帐号、密码丢失，可到考务系统<span class="sp-number-info"><a href="http://kw.clppx.org.cn" target="_blank">http://kw.clppx.org.cn</a></span>根据预留手机号进行账号密码找回。</p>

            </div>
        </div>
    </div>
    <el-dialog title="审核意见" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
        <div class="audit-opinion-main">
            {{auditOpinion}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" type="primary">关闭</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            dialogVisible: false,
            list: [],
            total: 0,
            kdName: "",
            kPassword: "",
            pageSize: 10,
            pageIndex: 1,
            schoolName: "", // 搜索条件
            auditOpinion: ""
        };
    },
    components: {
        imageUpload
    },
    created() {
        this.school = this.$store.state.auth.userName;
        this.getSchoolList(1);
        this.getSurplusNumber();
    },
    props: {
        certificateId: {
            type: String,
            default: ""
        }
    },
    methods: {
        getSchoolList(page) {
            var that = this;
            this.$http
                .post("/api/XOrg/AssessmentApply/getAssessmentApplyList", {
                    schoolName: this.schoolName,
                    certificateId: this.certificateId,
                    page: page,
                    pageSize: this.pageSize
                })
                .then(rst => {
                    if (rst.code == 1) {
                        this.list = rst.list;
                        this.total = rst.pagination.totalCount;
                        this.pageSize = rst.pagination.pageSize;
                        this.pageIndex = rst.pagination.pageIndex;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        onPageChangeHandler(page) {
            this.getSchoolList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getSchoolList();
        },
        getSurplusNumber() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssessmentApply/getSurplusNumber", {})
                .then(function (rst) {
                    if (rst.code > 0) {
                        // that.firstCount = rst.countOne;
                        // that.secondCount = rst.countTow;
                        // that.thirdCount = rst.countThree;
                        // that.fourthCount = rst.countFour;
                        that.kdName = rst.kdName;
                        that.kPassword = rst.kwPhone;
                        // that.ExamDateList = rst.dateList;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        search() {},
        editTable(id) {
            this.$router.push({
                name: 'editerExamTable',
                params: {
                    tableId: id
                }
            });
        },
        showAuditOpinion(auditOpinion) {
            this.auditOpinion = auditOpinion;
            this.dialogVisible = true;
        }
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper-1 {
    .news-page-con {
        padding: 20px 0;
        text-align: center;
    }

    .site-head-title-con {
        font-size: 16px;
        height: 40px;
        font-weight: bold;
    }

    .exam-affairs-info {
        margin: 20px 0;

        .text-notice {
            margin-top: 6px;
            font-size: 16px;

            span {
                margin-right: 10px;
            }
        }

        .sp-number-info {
            margin: 0 6px;
            font-size: 18px;
            color: #F56C6C;
        }

        a {
            color: #F56C6C;
        }
    }

    .d-search-form-news {
        margin: 13px 0px 0 0;
    }

    .ad-school-manager-head {

        width: calc(100% - 240px);

        text-align: right;
    }

    .u-table-apply {
        margin: 30px 0 0 30px;
    }
}
.audit-opinion-main {
    padding:20px;
    font-size:16px;
    line-height: 1.5;
}
</style>
